import { SuspenceWrapper } from "./styled";
import { OperatorPageLoading } from "../OperatorPageLoading";

export const SuspenceFallbackComponent = (): JSX.Element => (
  <SuspenceWrapper>
    <OperatorPageLoading tip="Loading page…" minHeight="100%" />
  </SuspenceWrapper>
);
